import { commonTranslationES } from "@common/translations/es";

export const emailTemplatesES = {
  ...commonTranslationES,
  'Save': 'Save',
  'New Template': 'New Template',
  'Delete Template': 'Delete Template',
  'Copy Template': 'Copy Template',
  'Failed to load email templates': 'Failed to load email templates',
  'Template Name': 'Template Name',
  Subject: 'Subject',
  Body: 'Body',
  Modified: 'Modified',
  'Locked (IRB Approved)': 'Locked (IRB Approved)',
  'Failed to delete template': 'Failed to delete template',
  'Are you sure you want to delete the selected email templates?': 'Are you sure you want to delete the selected email templates?',
  'Individual Data Folders': 'Individual Data Folders',
  'EDITOR': 'EDITOR',
  'Some of the selected email templates are still used in questionnaires:': 'Some of the selected email templates are still used in questionnaires:',
  'Do you want to delete them anyway?': 'Do you want to delete them anyway?',
};